module.exports = __webpack_public_path__ + "img/Storage=MNG-On.6b6402de.svg";